import {createRouter, createWebHistory} from 'vue-router'

// Guest Routes
import Sso from "@/pages/Auth/Sso.vue"
import Dev from "@/components/Dev.vue"
import Login from "@/pages/Auth/Login.vue"
import TwoFA from "@/pages/Auth/TwoFA.vue"
import Register from "@/pages/Auth/Register.vue"
import VerifyEmail from "@/pages/Auth/VerifyEmail.vue"
import ResetPassword from '@/pages/Auth/ResetPassword.vue'
import ForgotPassword from '@/pages/Auth/ForgotPassword.vue'
import ForceChangePassword from '@/pages/Auth/ForceChangePassword.vue'

// Auth Routes
import SKU from "@/pages/Device/SKU.vue"
import Role from "@/pages/Role/Index.vue"
import User from "@/pages/User/Index.vue"
import Asset from "@/pages/Asset/Index.vue"
import OTAFiles from "@/pages/OTA/Files.vue"
import Portal from "@/pages/Portal/Index.vue"
import Driver from "@/pages/Driver/Index.vue"
import Dispatch from "@/pages/Fleet/Dispatch.vue"
import FleetShifts from "@/pages/Fleet/Shifts.vue"
import FleetShiftSettings from "@/pages/Fleet/ShiftSettings.vue"
import DriverDetails from "@/pages/Driver/Details.vue"
import Device from "@/pages/Device/Index.vue"
import Site from "@/pages/Harvester/Site.vue"
import AssetType from "@/pages/Asset/Type.vue"
import Plans from "@/pages/Payments/Plans.vue"
import SimCard from "@/pages/SimCard/Index.vue"
import Company from "@/pages/Company/Index.vue"
import AdminIp from "@/pages/AdminIp/Index.vue"
import UserIpRestrictions from "@/pages/UserIpRestrictions/Index.vue"
import Gateway from "@/pages/Gateway/Index.vue"
import AssetGroup from "@/pages/Asset/Group.vue"
import Location from "@/pages/Location/Index.vue"
import LiveView from "@/pages/Dashboard/Live.vue"
import Settings from "@/pages/System/Settings.vue"
import Integrations from "@/pages/Integrations/Integrations.vue"
import OTAPackages from "@/pages/OTA/Packages.vue"
import CompanyInfo from "@/pages/Company/Info.vue"
import SimCardType from "@/pages/SimCard/Types.vue"
import MenuGroup from "@/pages/MenuGroup/Index.vue"
import Profile from "@/pages/Dashboard/Profile.vue"
import Dashboard from "@/pages/Dashboard/Index.vue"
import OTACampaigns from "@/pages/OTA/Campaigns.vue"
import Invoices from "@/pages/Payments/Invoices.vue"
import Harvesters from "@/pages/Harvester/Index.vue"
import AssetDetails from "@/pages/Asset/Details.vue"
import ComplianceCommandCenter from "@/pages/Compliance/CommandCenter.vue"
import AssetCompliance from "@/pages/Compliance/AssetCompliance.vue"
import ComplianceSubmissions from "@/pages/Compliance/Submissions.vue"
import DeviceDetails from "@/pages/Device/Details.vue"
import DeviceLogs from "@/pages/Device/Logs.vue"
import Schedule from "@/pages/Monitoring/Schedule.vue"
import WifiConfig from "@/pages/Configurations/Wifi.vue"
import Recipient from "@/pages/Monitoring/Recipient.vue"
import CompanyAccount from "@/pages/Company/Account.vue"
import DeviceGroup from "@/pages/Device/DeviceGroup.vue"
import DeviceConfig from "@/pages/DeviceConfig/Index.vue"
import Notification from "@/pages/Asset/Notification.vue"
import Activity from "@/pages/Activity/Index.vue"
import PaymentGateways from "@/pages/Payments/Gateways.vue"
import DeviceMessageLog from "@/pages/Device/MessageLog.vue"
import MonitoringConfig from "@/pages/Monitoring/Config.vue"
import DownLinkQueues from "@/pages/Device/DownlinkQueues.vue"
import BatteryGraphs from "@/pages/Dashboard/BatteryGraphs.vue"
import GpsGraphs from "@/pages/Dashboard/GpsGraphs.vue"
import RebootGraphs from "@/pages/Dashboard/RebootGraphs.vue"
import PaymentMethods from "@/pages/Company/PaymentMethods.vue"
import UserActivityLog from "@/pages/UserActivityLog/Index.vue"
import MonitoringTemplate from "@/pages/Monitoring/Template.vue"
import PersonalTrackers from "@/pages/PersonalTrackers/Index.vue"
import LegalDocuments from "@/pages/LegalDocuments/Index.vue"
import DiscountSchemes from "@/pages/Payments/DiscountSchemes.vue"
import Resellers from "@/pages/Resellers/Index.vue"
import DiscountCodes from "@/pages/Payments/DiscountCodes.vue"
import PresetGeneralConfig from "@/pages/AdminConfigs/PresetGeneralConfig.vue"
import PendingCompanies from "@/pages/Admin/PendingCompanies.vue"
import AdminAnnouncements from "@/pages/Admin/Announcements.vue"
import VerificationLogs from "@/pages/Admin/VerificationLogs.vue"
import CrmIntegrations from "@/pages/Admin/CrmIntegrations.vue"
import AppInstalls from "@/pages/Admin/AppInstalls/Index.vue"
import AppInstallDetails from "@/pages/Admin/AppInstalls/Details.vue"
import CtcOpsReadiness from "@/pages/Admin/Ctc/Readiness.vue"
import CtcOpsSubmissions from "@/pages/Admin/Ctc/Submissions.vue"
import CtcOpsSubmissionDetail from "@/pages/Admin/Ctc/SubmissionDetail.vue"
import RenewalDashboard from "@/pages/Admin/Renewals.vue"
import BusinessDashboard from "@/pages/Admin/Reports/Dashboard.vue"
import RevenueReport from "@/pages/Admin/Reports/Revenue.vue"
import GrowthReport from "@/pages/Admin/Reports/Growth.vue"
import OperationsReport from "@/pages/Admin/Reports/Operations.vue"
import SystemTools from "@/pages/System/Tools.vue"
import SetupWizard from "@/pages/Onboarding/SetupWizard.vue"
import CompanyDisabled from "@/pages/Auth/CompanyDisabled.vue"

import DeviceDiagnostics from "@/pages/DeviceDiagnostics/Index.vue"
import DriverPaymentTypes from "@/pages/Payments/DriverPaymentTypes.vue"
import DeviceDiagnosticMapping from "@/pages/DeviceDiagnostics/Mappings.vue"
import DeviceDiagnosticProfiles from "@/pages/DeviceDiagnostics/Profiles.vue"


import Trips from "@/pages/Report/Trips.vue"
import Summary from "@/pages/Report/Summary.vue"
import Compliance from "@/pages/Report/Compliance.vue"
import TripsSummary from "@/pages/Report/TripsSummary.vue"
import DriverReport from "@/pages/Report/DriverReport.vue"
import AssetsExpenseReport from "@/pages/Report/Fleet/AssetsExpense.vue";
import AssetsFuelRefill from "@/pages/Report/Fleet/AssetsFuelRefill.vue";
import AssetsSummaryReport from "@/pages/Report/Fleet/AssetsSummaryReport.vue";
import AssetsInspectionSummary from "@/pages/Report/Fleet/AssetsInspectionSummary.vue";
import VehicleUtilizationReport from "@/pages/Report/Fleet/VehicleUtilizationReport.vue";
import InspectionMaintenanceReport from "@/pages/Report/Fleet/InspectionMaintenanceReport.vue";
import AssetsMaintenanceCostSummary from "@/pages/Report/Fleet/AssetsMaintenanceCostSummary.vue";
import DriverSafetyAnalytics from "@/pages/Report/Fleet/DriverSafetyAnalytics.vue";
import SafetyEventsInbox from "@/pages/Report/Fleet/SafetyEventsInbox.vue";
import SafetyLeaderboard from "@/pages/Report/Fleet/SafetyLeaderboard.vue";
import CoachingSettings from "@/pages/Report/Fleet/CoachingSettings.vue";
import FleetInspections from "@/pages/Report/Fleet/Inspections.vue";
import FleetInspectionTemplates from "@/pages/Report/Fleet/InspectionTemplates.vue";
import ExpiringDocuments from "@/pages/Report/Fleet/ExpiringDocuments.vue";
import DriverAppRetired from "@/pages/LegacyDriverApp/Retired.vue";

import MaintenanceServiceType from "@/pages/Fleet/ServiceType.vue";
import FleetManufacturer from "@/pages/Fleet/Manufacturer.vue"
import ExpenseType from "@/pages/Fleet/ExpenseType.vue"
import FleetStatus from "@/pages/Fleet/Status.vue"
import FuelType from "@/pages/Fleet/FuelType.vue"
import FleetModel from "@/pages/Fleet/Model.vue"


const routes = [
    {
        path: "/",
        name: "home",
        redirect: (to) => {
            return {path: "/login"};
        },
    },
    {
        path: "/dev",
        name: "/dev",
        meta: {
            layout: "auth",
        },
        component: Dev,
    },
    {
        path: "/about",
        name: "about",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
    },
    {
        path: "/login",
        name: "login",
        meta: {
            layout: "guest",
        },
        component: Login,
    },
    {
        path: "/signup",
        name: "signup",
        meta: {layout: "guest"},
        component: () => import("@/pages/Auth/PhoneEntry.vue"),
    },
    {
        path: "/signup/verify",
        name: "phone-otp",
        meta: {layout: "guest"},
        component: () => import("@/pages/Auth/PhoneOtp.vue"),
    },
    {
        path: "/register/:token?",
        name: "register",
        meta: {
            layout: "guest",
        },
        component: Register,
    },
    {
        name: "sso",
        path: "/sso",
        component: Sso,
    },
    {
        path: "/change-password",
        name: "force-change-password",
        meta: {
            layout: "guest",
        },
        component: ForceChangePassword,
    },
    {
        path: "/forgot-password",
        name: "forgot-password",
        meta: {
            layout: "guest",
        },
        component: ForgotPassword,
    },
    {
        path: "/reset-password/:id",
        name: "reset-password",
        meta: {
            layout: "guest",
        },
        component: ResetPassword,
    },
    {
        path: "/verify-email/:id",
        name: "verify-email",
        meta: {
            layout: "guest",
        },
        component: VerifyEmail,
    },
    {
        path: "/two-fa",
        name: "two-fa",
        meta: {
            layout: "guest",
        },
        component: TwoFA,
    },
    {
        path: "/company-disabled",
        name: "company-disabled",
        meta: {
            layout: "guest",
        },
        component: CompanyDisabled,
    },
    {
        path: "/dashboard",
        name: "dashboard",
        meta: {
            layout: "auth",
        },
        component: Dashboard,
    },
    {
        path: "/battery-graphs/:asset",
        name: "battery-graphs",
        meta: {
            layout: "auth",
        },
        component: BatteryGraphs,
    },
    {
        path: "/gps-graphs/:asset",
        name: "gps-graphs",
        meta: {
            layout: "auth",
        },
        component: GpsGraphs,
    },
    {
        path: "/reboot-graphs/:asset",
        name: "reboot-graphs",
        meta: {
            layout: "auth",
        },
        component: RebootGraphs,
    },
    {
        path: "/live-view",
        name: "live-view",
        meta: {
            layout: "auth",
            subtitle: "Live View",
        },
        component: LiveView,
    },
    {
        path: "/profile",
        name: "profile",
        meta: {
            layout: "auth",
        },
        component: Profile,
    },
    {
        path: "/companies",
        name: "companies",
        meta: {
            layout: "auth",
        },
        component: Company,
    },
    {
        path: "/locations",
        name: "locations",
        meta: {
            layout: "auth",
        },
        component: Location,
    },
    {
        path: "/company-info",
        name: "company-info",
        meta: {
            layout: "auth",
        },
        component: CompanyInfo,
    },
    {
        path: "/company-account",
        name: "company-account",
        meta: {
            layout: "auth",
        },
        component: CompanyAccount,
    },
    {
        path: "/payment-methods",
        name: "payment-methods",
        meta: {
            layout: "auth",
        },
        component: PaymentMethods,
    },
    {
        path: "/driver-payment-methods",
        name: "driver-payment-methods",
        meta: {
            layout: "auth",
        },
        component: DriverPaymentTypes,
    },
    {
        path: "/roles",
        name: "roles",
        meta: {
            layout: "auth",
        },
        component: Role,
    },
    {
        path: "/user-activity-logs",
        name: "user-activity-logs",
        meta: {
            layout: "auth",
        },
        component: UserActivityLog,
    },
    {
        path: "/users",
        name: "users",
        meta: {
            layout: "auth",
        },
        component: User,
    },
    {
        path: "/fleet/dispatch",
        name: "fleet-dispatch",
        meta: {
            layout: "auth",
        },
        component: Dispatch,
    },
    {
        path: "/drivers",
        name: "drivers",
        meta: {
            layout: "auth",
        },
        component: Driver,
    },
    {
        path: "/drivers/:driver",
        name: "driver",
        meta: {
            layout: "auth",
            notFleetDriver: true,
        },
        component: DriverDetails,
    },
    {
        path: "/harvesters",
        name: "harvesters",
        meta: {
            layout: "auth",
        },
        component: Harvesters,
    },
    {
        path: "/personal-trackers",
        name: "personal-trackers",
        meta: {
            layout: "auth",
        },
        component: PersonalTrackers,
    },
    {
        path: "/harvesters/sites",
        name: "harvesters/sites",
        meta: {
            layout: "auth",
        },
        component: Site,
    },
    {
        path: "/sim-cards",
        name: "sim-cards",
        meta: {
            layout: "auth",
        },
        component: SimCard,
    },
    {
        path: "/sim-card-types",
        name: "sim-card-types",
        meta: {
            layout: "auth",
        },
        component: SimCardType,
    },
    {
        path: "/devices",
        name: "devices",
        meta: {
            layout: "auth",
        },
        component: Device,
    },
    {
        // Super admin only: these archives are location metadata.
        path: "/devices/logs",
        name: "device-logs",
        meta: {
            layout: "auth",
            super: true,
        },
        component: DeviceLogs,
    },
    {
        path: "/devices/:slno",
        name: "device",
        meta: {
            layout: "auth",
        },
        component: DeviceDetails,
    },
    {
        path: "/sku",
        name: "sku",
        meta: {
            layout: "auth",
        },
        component: SKU,
    },
    {
        path: "/diagnostics",
        name: "diagnostics",
        meta: {
            layout: "auth",
        },
        component: DeviceDiagnostics,
    },
    {
        path: "/diagnostic-profiles",
        name: "diagnostic-profiles",
        meta: {
            layout: "auth",
        },
        component: DeviceDiagnosticProfiles,
    },
    {
        path: "/diagnostic-payload-mapping",
        name: "diagnostic-payload-mapping",
        meta: {
            layout: "auth",
        },
        component: DeviceDiagnosticMapping,
    },
    {
        path: "/ota-files",
        name: "ota-files",
        meta: {
            layout: "auth",
        },
        component: OTAFiles,
    },
    {
        path: "/ota-packages",
        name: "ota-packages",
        meta: {
            layout: "auth",
        },
        component: OTAPackages,
    },
    {
        path: "/ota-campaigns",
        name: "ota-campaigns",
        meta: {
            layout: "auth",
        },
        component: OTACampaigns,
    },
    {
        path: "/message-log",
        name: "messageLog",
        meta: {
            layout: "auth",
        },
        component: DeviceMessageLog,
    },
    {
        path: "/downlink-queues",
        name: "downlinkQueues",
        meta: {
            layout: "auth",
        },
        component: DownLinkQueues,
    },
    {
        path: "/assets",
        name: "assets",
        meta: {
            layout: "auth",
        },
        component: Asset,
    },
    {
        path: "/assets/:asset",
        name: "asset",
        meta: {
            layout: "auth",
        },
        component: AssetDetails,
    },
    {
        path: "/compliance",
        name: "ctc-compliance",
        meta: {
            layout: "auth",
        },
        component: ComplianceCommandCenter,
    },
    {
        path: "/compliance/assets/:asset",
        name: "ctc-asset",
        meta: {
            layout: "auth",
        },
        component: AssetCompliance,
    },
    {
        path: "/compliance/submissions",
        name: "ctc-submissions",
        meta: {
            layout: "auth",
        },
        component: ComplianceSubmissions,
    },
    {
        path: "/admin/ctc/readiness",
        name: "admin-ctc-readiness",
        meta: {
            layout: "auth",
            super: true,
        },
        component: CtcOpsReadiness,
    },
    {
        path: "/admin/ctc/submissions",
        name: "admin-ctc-submissions",
        meta: {
            layout: "auth",
            super: true,
        },
        component: CtcOpsSubmissions,
    },
    {
        path: "/admin/ctc/submissions/:id",
        name: "admin-ctc-submission",
        meta: {
            layout: "auth",
            super: true,
        },
        component: CtcOpsSubmissionDetail,
    },
    {
        path: "/asset-types",
        name: "asset-types",
        meta: {
            layout: "auth",
        },
        component: AssetType,
    },
    {
        path: "/notifications",
        name: "notifications",
        meta: {
            layout: "auth",
        },
        component: Notification,
    },
    {
        path: "/activity",
        name: "activity",
        meta: {
            layout: "auth",
        },
        component: Activity,
    },
    {
        path: "/asset-groups",
        name: "asset-groups",
        meta: {
            layout: "auth",
        },
        component: AssetGroup,
    },
    {
        path: "/device-group",
        name: "device-group",
        meta: {
            layout: "auth",
        },
        component: DeviceGroup,
    },
    {
        path: "/gateways",
        name: "gateways",
        meta: {
            layout: "auth",
        },
        component: Gateway,
    },
    {
        path: "/configurations/wifi",
        name: "configurations/wifi",
        meta: {
            layout: "auth",
        },
        component: WifiConfig,
    },
    {
        path: "/monitoring-configs",
        name: "monitoring-configs",
        meta: {
            layout: "auth",
        },
        component: MonitoringConfig,
    },
    {
        path: "/monitoring-templates",
        name: "monitoring-templates",
        meta: {
            layout: "auth",
        },
        component: MonitoringTemplate,
    },
    {
        path: "/recipients",
        name: "recipients",
        meta: {
            layout: "auth",
        },
        component: Recipient,
    },
    {
        path: "/monitoring-schedules",
        name: "monitoring-schedules",
        meta: {
            layout: "auth",
        },
        component: Schedule,
    },
    {
        path: "/preset-general-config",
        name: "preset-general-config",
        meta: {
            layout: "auth",
        },
        component: PresetGeneralConfig,
    },
    {
        path: "/legal-documents",
        name: "legal-documents",
        meta: {
            layout: "auth",
        },
        component: LegalDocuments,
    },
    {
        path: "/summary-report",
        name: "summary-report",
        meta:
            {
                layout: "auth",
            },
        component: Summary,
    },
    {
        path: "/trips-summary",
        name: "trips-summary",
        meta:
            {
                layout: "auth",
            },
        component: TripsSummary,
    },
    {
        path: "/trips-report/:asset?/:type?/:company?",
        name: "trips-report",
        meta:
            {
                layout: "auth",
            },
        component: Trips,
    },
    {
        path: "/driver-report",
        name: "driver-report",
        meta:
            {
                layout: "auth",
            },
        component: DriverReport,
    },
    {
        path: "/reports/compliance",
        name: "reports/compliance",
        meta:
            {
                layout: "auth",
            },
        component: Compliance,
    },
    {
        path: "/settings",
        name: "settings",
        meta:
            {
                layout: "auth",
            },
        component: Settings,
    },
    {
        path: "/integrations",
        name: "integrations",
        meta: {
            layout: "auth",
        },
        component: Integrations,
    },
    {
        path: "/system-tools",
        name: "system-tools",
        meta:
            {
                layout: "auth",
            },
        component: SystemTools,
    },
    {
        path: "/admin-ips",
        name: "admin-ips",
        meta:
            {
                layout: "auth",
            },
        component: AdminIp,
    },
    {
        // Super admin only screen for managing the per user IP allowlist.
        // The component itself re checks authStore.user.super on mount and
        // redirects non super admins back to /users so deep linking by a
        // regular admin cannot reach the surface.
        path: "/users/:userId/ip-restrictions",
        name: "user-ip-restrictions",
        meta: {layout: "auth"},
        component: UserIpRestrictions,
        props: true,
    },
    {
        path: "/pending-companies",
        name: "pending-companies",
        meta:
            {
                layout: "auth",
            },
        component: PendingCompanies,
    },
    {
        path: "/admin/announcements",
        name: "admin-announcements",
        meta: {layout: "auth", super: true},
        component: AdminAnnouncements,
    },
    {
        path: "/admin/verification-logs",
        name: "admin-verification-logs",
        meta: {layout: "auth", super: true},
        component: VerificationLogs,
    },
    {
        path: "/admin/app-installs",
        name: "admin-app-installs",
        meta: {layout: "auth", super: true},
        component: AppInstalls,
    },
    {
        path: "/admin/app-installs/:id(\\d+)",
        name: "admin-app-install",
        meta: {layout: "auth", super: true},
        component: AppInstallDetails,
    },
    {
        path: "/admin/crm-integrations",
        name: "admin-crm-integrations",
        meta: {layout: "auth", super: true},
        component: CrmIntegrations,
    },
    {
        path: "/renewal-dashboard",
        name: "renewal-dashboard",
        // super, not just admin_access: this page holds the switch that starts
        // charging cards unattended. The API enforces the same rule.
        meta: {layout: "auth", super: true},
        component: RenewalDashboard,
    },
    {
        path: "/business-dashboard",
        name: "business-dashboard",
        meta: { layout: "auth" },
        component: BusinessDashboard,
    },
    {
        path: "/revenue-report",
        name: "revenue-report",
        meta: { layout: "auth" },
        component: RevenueReport,
    },
    {
        path: "/growth-report",
        name: "growth-report",
        meta: { layout: "auth" },
        component: GrowthReport,
    },
    {
        path: "/operations-report",
        name: "operations-report",
        meta: { layout: "auth" },
        component: OperationsReport,
    },
    {
        path: "/portals",
        name: "portals",
        meta:
            {
                layout: "auth",
            },
        component: Portal,
    },
    {
        // Super admin only. The page itself re-checks, and every endpoint behind it
        // refuses anyone else, so a typed URL shows an access message and no data.
        path: "/resellers",
        name: "resellers",
        meta:
            {
                layout: "auth",
            },
        component: Resellers,
    },
    {
        path: "/discount-schemes",
        name: "discount-schemes",
        meta:
            {
                layout: "auth",
            },
        component: DiscountSchemes,
    },
    {
        path: "/discount-codes",
        name: "discount-codes",
        meta:
            {
                layout: "auth",
            },
        component: DiscountCodes,
    },
    {
        path: "/menu-groups",
        name: "menu-groups",
        meta:
            {
                layout: "auth",
            },
        component: MenuGroup,
    },
    {
        path: "/payment-gateways",
        name: "payment-gateways",
        meta:
            {
                layout: "auth",
            },
        component: PaymentGateways,
    },
    {
        path: "/subscription-plans",
        name: "subscription-plans",
        meta:
            {
                layout: "auth",
            },
        component: Plans,
    },
    {
        path: "/invoices",
        name: "invoices",
        meta:
            {
                layout: "auth",
            },
        component: Invoices,
    },
    {
        path: "/device-configs/:type?",
        name: "device-configs",
        meta:
            {
                layout: "auth",
            },
        component: DeviceConfig,
    },
    {
        path: "/fleet/manufacturers",
        name: "fleet/manufacturers",
        meta:
            {
                layout: "auth",
            },
        component: FleetManufacturer,
    },
    {
        path: "/fleet/statuses",
        name: "fleet/statuses",
        meta:
            {
                layout: "auth",
            },
        component: FleetStatus,
    },
    {
        path: "/fleet/models",
        name: "fleet/models",
        meta:
            {
                layout: "auth",
            },
        component: FleetModel,
    },
    {
        path: "/fleet/fuel-types",
        name: "fleet/fuel-types",
        meta:
            {
                layout: "auth",
            },
        component: FuelType,
    },
    {
        path: "/fleet/expense-types",
        name: "fleet/expense-types",
        meta:
            {
                layout: "auth",
            },
        component: ExpenseType,
    },
    {
        path: "/fleet/service-types/:type",
        name: "fleet/service-types",
        meta:
            {
                layout: "auth",
            },
        component: MaintenanceServiceType,
    },
    {
        path: "/fleet/reports/inspection-summary",
        name: "fleet/reports/inspection-summary",
        meta:
            {
                layout: "auth",
            },
        component: AssetsInspectionSummary,
    },
    {
        path: "/fleet/reports/assets-summary",
        name: "fleet/reports/assets-summary",
        meta:
            {
                layout: "auth",
            },
        component: AssetsSummaryReport,
    },
    {
        path: "/fleet/reports/assets-expense",
        name: "fleet/reports/assets-expense",
        meta:
            {
                layout: "auth",
            },
        component: AssetsExpenseReport,
    },
    {
        path: "/fleet/reports/assets-fuel-refill",
        name: "fleet/reports/assets-fuel-refill",
        meta:
            {
                layout: "auth",
            },
        component: AssetsFuelRefill,
    },
    {
        path: "/fleet/reports/expiring-documents",
        name: "fleet/reports/expiring-documents",
        meta:
            {
                layout: "auth",
                notFleetDriver: true,
            },
        component: ExpiringDocuments,
    },
    {
        path: "/fleet/reports/maintenance-summary",
        name: "fleet/reports/maintenance-summary",
        meta:
            {
                layout: "auth",
            },
        component: AssetsMaintenanceCostSummary,
    },
    {
        path: "/fleet/reports/vehicle-utilization",
        name: "fleet/reports/vehicle-utilization",
        meta:
            {
                layout: "auth",
            },
        component: VehicleUtilizationReport,
    },
    {
        path: "/fleet/reports/inspection-maintenance",
        name: "fleet/reports/inspection-maintenance",
        meta:
            {
                layout: "auth",
            },
        component: InspectionMaintenanceReport,
    },
    {
        path: "/fleet/reports/driver-safety",
        name: "fleet/reports/driver-safety",
        meta:
            {
                layout: "auth",
            },
        component: DriverSafetyAnalytics,
    },
    {
        path: "/fleet/reports/safety-inbox",
        name: "fleet/reports/safety-inbox",
        meta:
            {
                layout: "auth",
            },
        component: SafetyEventsInbox,
    },
    {
        path: "/fleet/reports/safety-leaderboard",
        name: "fleet/reports/safety-leaderboard",
        meta:
            {
                layout: "auth",
            },
        component: SafetyLeaderboard,
    },
    {
        path: "/fleet/reports/coaching-settings",
        name: "fleet/reports/coaching-settings",
        meta:
            {
                layout: "auth",
                notFleetDriver: true,
            },
        component: CoachingSettings,
    },
    {
        path: "/fleet/shifts",
        name: "fleet/shifts",
        meta:
            {
                layout: "auth",
                notFleetDriver: true,
            },
        component: FleetShifts,
    },
    {
        path: "/fleet/shift-settings",
        name: "fleet/shift-settings",
        meta:
            {
                layout: "auth",
                notFleetDriver: true,
            },
        component: FleetShiftSettings,
    },
    {
        path: "/fleet/inspections",
        name: "fleet/inspections",
        meta:
            {
                layout: "auth",
                notFleetDriver: true,
            },
        component: FleetInspections,
    },
    {
        path: "/fleet/inspection-templates",
        name: "fleet/inspection-templates",
        meta:
            {
                layout: "auth",
                notFleetDriver: true,
            },
        component: FleetInspectionTemplates,
    },
    {
        path: "/setup-wizard",
        name: "setup-wizard",
        meta: {
            layout: "wizard",
        },
        component: SetupWizard,
    },
    // The driver web app that lived under /drive was retired for the native
    // SimpliGPS Driver app. Old bookmarks and home screen installs land here.
    {
        path: "/drive/:pathMatch(.*)*",
        name: "driver-app-retired",
        meta: {layout: "driver", title: "SimpliGPS Driver"},
        component: DriverAppRetired,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes
});
router.beforeEach(async (to, from, next) => {
    const baseTitle = process.env.VUE_APP_TITLE;
    document.title = to.meta.title || (to.meta.subtitle ? `${baseTitle} - ${to.meta.subtitle}` : baseTitle);

    // Auth guard: redirect unauthenticated users to login. Before this
    // guard existed, an unauth user hitting /assets would load the page
    // and trigger 401s per-request that the Axios interceptor then
    // redirected on - a noticeable flash of an empty shell, plus
    // misleading 401 errors in the server logs for every XHR the
    // in-flight page fired. Guarding at the router stops navigation
    // before any resource loads.
    // 'wizard' too: the setup wizard uses its own layout so it can bypass
    // Auth.vue's restricted mode, and that left it matching no guarded
    // branch at all - reachable with no session, then every XHR it fires
    // comes back Unauthenticated. The block below that redirects INTO the
    // wizard stays 'auth' only, or it would redirect the wizard to itself.
    if (to.meta.layout === 'auth' || to.meta.layout === 'wizard') {
        try {
            const {useAuthStore} = await import('@/stores/authStore');
            const authStore = useAuthStore();
            if (!authStore.isAuthenticated()) {
                return next({name: 'login', query: {redirect: to.fullPath}});
            }
            // If a company-type user's current company is disabled (company=null
            // in their profile), redirect to the suspension page so they can
            // contact support or switch to another active company.
            if (
                authStore.user?.type === 'company' &&
                authStore.user?.company === null &&
                to.name !== 'company-disabled'
            ) {
                return next({name: 'company-disabled'});
            }
            // Super-admin-only surfaces (e.g. CARB ops: raw OBD captures).
            // Stop navigation at the router so a non-super admin deep-linking
            // the page never mounts it and never fires its data requests -
            // the per-component on-mount redirect was a flash + a wasted XHR.
            if (to.meta.super && !authStore.user?.super) {
                return next({name: 'dashboard'});
            }
            // Manager pages the API refuses the Fleet Driver role. Sent from
            // login and switch-company as user.is_fleet_driver.
            if (to.meta.notFleetDriver && authStore.user?.is_fleet_driver) {
                return next({name: 'dashboard'});
            }
        } catch {
            // authStore import failed - let navigation through; the
            // page will surface whatever error caused the import to break.
        }
    }

    // Authenticated users shouldn't be able to re-enter login / signup /
    // forgot-password screens unless they've intentionally logged out.
    // Guard guest-layout auth routes only (login, signup, verify-email,
    // forgot/reset-password, SSO, phone-entry/otp).
    if (to.meta.layout === 'guest') {
        try {
            const {useAuthStore} = await import('@/stores/authStore');
            const authStore = useAuthStore();
            const guestGuardedNames = new Set([
                'login', 'signup', 'forgot-password', 'reset-password',
                'verify-email', 'phone-entry', 'phone-otp', 'sso', 'two-fa',
            ]);
            if (authStore.isAuthenticated() && guestGuardedNames.has(to.name)) {
                const {landingRoute} = await import('@/composables/globals');
                return next({name: landingRoute(authStore)});
            }
        } catch {
            // authStore import failed - harmless, fall through.
        }
    }

    // Setup wizard guard: redirect company admins with 0 devices
    if (to.meta.layout === 'auth') {
        try {
            const {useAuthStore} = await import('@/stores/authStore');
            const {useOnboardingStore} = await import('@/stores/onboardingStore');
            const {send} = await import('@/composables/apiClient');
            const authStore = useAuthStore();
            const onboardingStore = useOnboardingStore();

            if (authStore.isAuthenticated()) {
                const user = authStore.user;
                const isCompanyAdmin = user?.type === 'company' && user?.role?.toLowerCase()?.includes('admin');

                // wizardDismissed: the user chose Skip for now. Without
                // honouring it they are pushed back into the wizard on
                // every navigation and cannot reach the app at all
                // until they add a payment method.
                if (isCompanyAdmin && !onboardingStore.hasCompletedSetup
                    && !onboardingStore.wizardDismissed) {
                    // Pending legal consents take precedence over the setup
                    // wizard. The wizard route uses layout='wizard', which
                    // bypasses Auth.vue's restrictedMode - so forcing new
                    // users into the wizard would hide the TakeConsent
                    // dialog entirely and they'd only see it AFTER
                    // finishing the wizard. Letting the auth-layout page
                    // render first puts the consent gate before anything
                    // else (onboarding flow bug reported 2026-04-19).
                    if (Array.isArray(authStore.consents) && authStore.consents.length > 0) {
                        return next();
                    }
                    if (!onboardingStore._deviceCheckDone) {
                        try {
                            const response = await send('get', 'devices/list', {per_page: 1});
                            const total = response.data?.data?.devices?.meta?.total
                                ?? response.data?.data?.devices?.data?.length
                                ?? response.data?.data?.meta?.total
                                ?? 0;
                            onboardingStore.setDeviceCheckResult(total);
                        } catch {
                            onboardingStore.setDeviceCheckResult(1); // Assume has devices on error
                        }
                    }
                    if (onboardingStore._deviceCheckDone && onboardingStore._deviceCount === 0) {
                        return next({name: 'setup-wizard'});
                    }
                    // If they have devices, mark setup complete so we skip future checks
                    if (onboardingStore._deviceCheckDone && onboardingStore._deviceCount > 0) {
                        onboardingStore.markSetupComplete();
                    }
                }
            }
        } catch {
            // Guard failed silently - let navigation proceed
        }
    }

    next();
});

export default router
